/**
 * [Gurumi 에디터 API]
 * 역할: upload/import/linkPreview — webeditor photo_uploader 방식 포함
 * 작성/수정일: 2026-07-29
 */
export async function uploadImage(file, config) {
  const editorUrl = config.editorUrl || config.pluginUrl || '';
  const nonce = config.uploadNonce || config.nonce || '';

  // webeditor 동일: GET _nonce + field name `file`
  const uploadUrl =
    (config.endpoints && config.endpoints.upload) ||
    `${editorUrl}/photo_uploader/upload.php`;

  const form = new FormData();
  form.append('file', file);

  const url = uploadUrl + (uploadUrl.indexOf('?') >= 0 ? '&' : '?') + '_nonce=' + encodeURIComponent(nonce);
  const res = await fetch(url, { method: 'POST', body: form, credentials: 'same-origin' });
  const data = await res.json();
  if (!res.ok || !data.success) throw new Error(data.message || '이미지 업로드에 실패했습니다.');
  return data;
}

export async function importImage(url, config) {
  const endpoints = config.endpoints || {};
  const form = new FormData();
  form.append('url', url);
  form.append('nonce', config.uploadNonce || config.nonce || '');
  if (config.boTable) form.append('bo_table', config.boTable);

  const res = await fetch(endpoints.import || `${config.editorUrl}/import.php`, {
    method: 'POST',
    body: form,
    credentials: 'same-origin',
  });
  const data = await res.json();
  if (!res.ok || !data.success) throw new Error(data.message || '이미지를 가져오지 못했습니다.');
  return data;
}

export async function fetchLinkPreview(url, config) {
  const endpoints = config.endpoints || {};
  const nonce = config.uploadNonce || config.nonce || '';
  const endpoint = endpoints.linkPreview || `${config.editorUrl}/link_preview.php`;
  const res = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Gurumi-Nonce': nonce,
    },
    body: JSON.stringify({ url, nonce }),
    credentials: 'same-origin',
  });
  const data = await res.json();
  if (!res.ok || !data.success) throw new Error(data.message || '링크 미리보기를 가져오지 못했습니다.');
  return data;
}
